import { useEffect, useRef } from "react";
import { useConfirmEmailChangeMutation } from "entities/user";
import { getConfirmEmailChangeError } from "./getEmailChangeErrors";

interface UseConfirmEmailChangeResult {
  isConfirming: boolean;
  isConfirmed: boolean;
  error: string | null;
}

export const useConfirmEmailChange = (
  token: string,
): UseConfirmEmailChangeResult => {
  const [confirm, { isLoading, isSuccess, error }] =
    useConfirmEmailChangeMutation();
  // Токен одноразовый: StrictMode запускает эффект дважды, второй запрос
  // вернул бы ошибку "invalid token" поверх успешного подтверждения.
  const isSentRef = useRef(false);

  useEffect(() => {
    if (!token || isSentRef.current) return;
    isSentRef.current = true;
    confirm({ token });
  }, [token, confirm]);

  return {
    isConfirming: isLoading,
    isConfirmed: isSuccess,
    error: getConfirmEmailChangeError(error),
  };
};
